import { createContext } from "react";

const widthContext = createContext({ width: window.innerWidth });

export default widthContext;
